// Debug utility for authentication and routing issues
const DEBUG = process.env.NODE_ENV === 'development';

export const debugLog = (message, data = null) => {
  if (DEBUG) {
    // console.log(`[DEBUG] ${message}`, data || '');
  }
};

export const debugError = (message, error = null) => {
  if (DEBUG) {
    console.error(`[DEBUG ERROR] ${message}`, error || '');
  }
};

export const debugAuth = (action, data = null) => {
  debugLog(`AUTH: ${action}`, data);
};

export const debugRoute = (action, data = null) => {
  debugLog(`ROUTE: ${action}`, data);
};

export const debugAPI = (action, data = null) => {
  debugLog(`API: ${action}`, data);
};

// Helper to check if we're in a valid state
export const validateAuthState = (authContext) => {
  if (!authContext) {
    debugError('Auth context is null or undefined');
    return false;
  }
  
  const { user, loading, isAuthenticated } = authContext;
  
  debugLog('Auth state validation:', {
    hasUser: !!user,
    loading,
    isAuthenticated: isAuthenticated(),
    userToken: user?.token ? 'present' : 'missing',
    userRoles: user?.roles || []
  });
  
  return true;
}; 